import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Button from '../../components/Button'
import Header from '../../components/Header'

export default function PasswordGate({ children }) {
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const redirectURL = queryParams.get('redirect');

  const PASSWORD = 'coffee';

  const handleSubmit = (e) => {
    e.preventDefault();

   if (password === PASSWORD) {
     window.location.href = redirectURL;
     setPasswordError(false);
   } else {
     setPasswordError(true);
     setPassword('');
   }
  };

  return (
    <>
      <Header mini />
      <div className="password">
        <header>
          <h2>What's the magic word?</h2>
        </header>
      <p>I'd <span role="img" aria-label="heart">❤️</span> to show you what I've worked on, but lawsuits are expensive. Reach out to me on <a href="https://www.linkedin.com/in/itsmedrew/" target="_blank" rel="noopener noreferrer">LinkedIn</a> or by <a href="mailto:drew@itsmedrew.com?subject = Magic Word&body = I'd like to read your full case study.">e-mail</a>. I'm the world's fastest responder.</p>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          value={password}
          placeholder="Magic word"
          onChange={e => setPassword(e.target.value)}
          style={{ borderColor: passwordError ? 'red' : undefined }}
        />
        {passwordError && <div style={{ color: 'red' }}>Please try again or reach out to me for the password.</div>}
        <Button className="form__button" type="submit" variant="primary">Submit</Button>
      </form>
    </div>
    </>
  );
}
